import * as St from './TermsAndConditionsModal.styles';

import DocumentViewer from '~atoms/DocumentViewer';

type TermsAndConditionsModalProps = {
  title: string;
  documentURL: string;
  isVisible: boolean;
  onClose: () => void;
};

const TermsAndConditionsModal = ({
  documentURL,
  ...props
}: TermsAndConditionsModalProps): JSX.Element => (
  <St.Container
    {...props}
    content={<DocumentViewer url={documentURL} />}
    footer={
      <a href={documentURL} target="_blank" rel="noopener noreferrer">
        Print this document
      </a>
    }
  />
);

export default TermsAndConditionsModal;
